'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var breakout_selector_html_1 = __importDefault(require("@public-templates/breakout-selector.html"));
(function (app) {
    app
        .directive('breakoutSelector', breakoutSelectorDirective)
        .factory('breakoutMenu', breakoutMenuFactory);
    breakoutSelectorDirective.$inject = ['breakoutMenu'];
    function breakoutSelectorDirective(breakoutMenu) {
        return {
            require: '?ngModel',
            templateUrl: breakout_selector_html_1.default,
            scope: {},
            link: breakoutSelectorLink
        };
        function breakoutSelectorLink(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }
            angular.extend(scope, {
                vm: {}
            });
            ngModel.$render = render;
            setLabel();
            function render() {
                scope.vm = {
                    breakout: ngModel.$viewValue
                };
                setLabel();
            }
            function setLabel() {
                breakoutMenu.getLabel(scope.vm.breakout)
                    .then(function (label) {
                    scope.vm.label = label;
                })
                    .catch(function (err) {
                    console.error(err);
                });
            }
        }
    }
    breakoutMenuFactory.$inject = [
        'rsWidgets',
        '$injector',
        'translateFilter',
        '$q',
    ];
    function breakoutMenuFactory(rsWidgets, injector, translate, $q) {
        var service = {
            getLabel: getLabel
        };
        return service;
        function getMenu(currentBreakout) {
            return rsWidgets.ensureDependency('dependencies/viewresults/source-configuration')
                .then(getService)
                .then(getMenuItems);
            function getMenuItems(fieldSetViewMenu) {
                return fieldSetViewMenu.getMenuItems({
                    supportedFieldTypes: [
                        'EnumerableValue',
                        'EnumerableValueSet',
                        'EnumerableScalarValue'
                    ],
                    includeNone: true
                }, currentBreakout);
            }
        }
        function getLabel(breakout) {
            if (!breakout) {
                return $q.resolve('');
            }
            return getMenu(breakout)
                .then(findSelectedLabel);
            function findSelectedLabel(menuItems) {
                var selectedMenuItem = _.chain(menuItems)
                    .flatMap(flattenSubMenus)
                    .find('selected')
                    .value();
                return selectedMenuItem &&
                    (selectedMenuItem.sourceLabel || selectedMenuItem.label);
            }
        }
        function getService() {
            return injector.get('viewresults.sourceConfiguration.fieldSetViewMenu');
        }
        function flattenSubMenus(menuItem) {
            return menuItem.submenu ? _.map(menuItem.submenu.items, flattenSubMenus) : menuItem;
        }
    }
})(angular.module('reporting.dashboards'));
